import React, { FC, ReactNode } from 'react';
import { Popover } from '@gravity-ui/uikit';
import { CircleQuestion } from '@gravity-ui/icons';

type QuestionIconPopoverProps = {
    popoverContent: ReactNode;
    style?: Record<string, string>;
};

export const QuestionIconPopover: FC<QuestionIconPopoverProps> = ({ popoverContent, style }) => {
    return (
        <>
            <Popover content={popoverContent}>
                <span
                    style={{
                        paddingLeft: '5px',
                        display: 'inline-block',
                        pointerEvents: 'auto',
                        ...style,
                    }}
                >
                    <CircleQuestion />
                </span>
            </Popover>
        </>
    );
};
